import React, { useState, useEffect } from 'react'
import Sidebar from '../../components/Sidebar';
import './unidades.css'
import { useUnits } from '../../context/unitsContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPlus, faSearch } from '@fortawesome/free-solid-svg-icons';
import RegisterUnit from '../Unidades/registerUnit';
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import Header from '../../components/header';

function Units() {
  const { listUnits } = useUnits();
  const [units, setUnits] = useState([]);
  const [showRegisterUnit, setShowRegisterUnit] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;
  const pageCount = Math.ceil((units || []).length / itemsPerPage);


  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const toggleRegisterUnit = () => {
    setShowRegisterUnit(!showRegisterUnit);
  };

  useEffect(() => {
    const fetchUnits = async () => {
      const unitsData = await listUnits();
      if (unitsData) {
        setUnits(unitsData.results);
      }
    };

    fetchUnits();
  }, [listUnits]);

  const handleUnitSave = async () => {
    setShowRegisterUnit(false);
    const response = await listUnits();
    if (response) {
      setUnits(response);
    }
  };

  // Filtro de busca
  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const handleSearchChange = (event) => {
    setSearchTerm(removeAccents(event.target.value.toLowerCase()));
  };

  const filteredUnits = (units || []).filter((unit) => {
    if (searchTerm === '') return true;
    return unit.name && unit.name.toLowerCase().includes(searchTerm.toLowerCase());
  });




  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container'>

        <div className='searchContainer'>
          <form>
            <div className="search-wrapper">
              <input
                type="text"
                id="searchInput"
                placeholder='Pesquisar por nome'
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <FontAwesomeIcon icon={faSearch} className='search-icon' />
            </div>
          </form>
          <div>
            <button className='btnAdcionar' onClick={toggleRegisterUnit}>
              {showRegisterUnit ? 'X' : <FontAwesomeIcon icon={faPlus} className='i' />}
            </button>
          </div>
        </div>

        {/* so mostrado para quem tem o campo de unidade vazio */}
        {/* Renderiza Tela de cadastro de Unidade */}
        {showRegisterUnit && (
          <div className='content-register'>
            <RegisterUnit onSave={handleUnitSave} />
          </div>
        )}

        <div className='content table-units content-table '>
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Sigla</th>
                <th>Cidade</th>
                <th>Telefone</th>
                <th>Email</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filteredUnits.length > 0 ? (
                filteredUnits
                  .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage)
                  .map((unit) => (
                    <tr key={unit.id}>
                      <td>{unit.name}</td>
                      <td>{unit.acronym}</td>
                      <td>{unit.city}</td>
                      <td>{unit.phone}</td>
                      <td>{unit.institutional_email}</td>
                      <td>
                        <Link to={`/unidades/${unit.id}`}>
                          <FontAwesomeIcon icon={faEye} />
                        </Link>
                      </td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan="6">Nenhuma unidade encontrada.</td>
                </tr>
              )}
            </tbody>
          </table>

          <ReactPaginate
            previousLabel={'<'}
            nextLabel={'>'}
            breakLabel={'...'}
            pageCount={pageCount}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'activeNumber'}
            previousClassName={'prev'}
            nextClassName={'next'}
            pageClassName={'page'}
            breakClassName={'break-me'}
          />
        </div>

      </div>
    </div>
  )
}

export default Units;